import React from "react";
import Modal from "./Modal.tsx";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "../Forms/InputField";
import { Auth } from "aws-amplify";
import toast from "react-hot-toast";

const validationSchema = Yup.object().shape({
  given_name: Yup.string().required("First name is required"),
  family_name: Yup.string().required("Last name is required"),
  username: Yup.string().required("Username is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters long")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(/[\W_]/, "Password must contain at least one special character")
    .required("Password is required"),
  email: Yup.string().required("Email is required").email("Invalid email"),
});

export default function Signup({ isModalOpen, setIsModalOpen }) {
  const [isLoading, setIsLoading] = React.useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await Auth.signUp({
        username: data.username,
        password: data.password,
        attributes: {
          email: data.email,
          given_name: data.given_name,
          family_name: data.family_name,
        },
      });
      toast.success("User created successfully");
      setIsModalOpen(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to create user");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Modal
        title="Create access user"
        onCancel={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        size="md"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form__section">
            <InputField
              control={control}
              name="given_name"
              label="First name"
              error={errors.given_name?.message}
              required
            />
            <InputField
              control={control}
              name="family_name"
              label="Last name"
              error={errors.family_name?.message}
              required
            />
            <InputField
              control={control}
              name="email"
              label="Email"
              type="email"
              error={errors.email?.message}
              required
            />
            <InputField
              control={control}
              name="username"
              label="Username"
              error={errors.username?.message}
              required
            />
            <InputField
              control={control}
              name="password"
              label="Password"
              type="password"
              error={errors.password?.message}
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn__primary btn--block"
            disabled={isLoading}
          >
            {isLoading ? "Loading" : "Submit"}
          </button>
        </form>
      </Modal>
    </div>
  );
}
